import { render } from "./TopDebtors.vue?vue&type=template&id=4db159bb&scoped=true"
import script from "./TopDebtors.vue?vue&type=script&lang=js"
export * from "./TopDebtors.vue?vue&type=script&lang=js"

import "./TopDebtors.vue?vue&type=style&index=0&id=4db159bb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db159bb"]])

export default __exports__